import React, { useEffect } from 'react';
import analyticsService from '../services/analytics';

/**
 * Higher-order component to track page views
 * @param {Component} WrappedComponent - React component to wrap
 * @param {string} pageName - Name of the page (optional, defaults to path)
 * @returns {Component} - Component with page tracking
 */
export function withPageTracking(WrappedComponent, pageName) {
  return function PageTrackingComponent(props) {
    useEffect(() => {
      // Use provided pageName or extract from URL
      const page = pageName || window.location.pathname;
      
      // Skip tracking for the home page since it's just a container for tabs
      if (page !== '/home') {
        analyticsService.trackPageView(page);
      }
    }, []);

    return <WrappedComponent {...props} />;
  };
} 